export const ENV_CONFIG = {
  apiUrl: process.env.REACT_APP_API_apiBaseUrl ?? '',
  loginUrl: process.env.REACT_APP_API_loginApiBaseUrl ?? '',

  loginAuthorization: process.env.REACT_APP_API_loginAuthorization,
  loggedInAuthorization: process.env.REACT_APP_API_loggedInAuthorization,
  authorization: process.env.REACT_APP_API_authorization,
  production: process.env.REACT_APP_API_production,
  environment: process.env.REACT_APP_API_environment,
  showEnvironment: process.env.REACT_APP_API_showEnvironment,
  authorization1: process.env.REACT_APP_API_authorization1,
  authorization2: process.env.REACT_APP_API_authorization2,
  authKeyApi: process.env.REACT_APP_API_authKeyApi ?? '',
  getSignedUrlApi: process.env.REACT_APP_API_getSignedUrlApi ?? '',
  readingFileApi: process.env.REACT_APP_API_readingFileApi ?? '',

  // RESPONSE_ENC_KEY — shared secret used to AES-decrypt the login token so the
  // JWT claims can be read client-side (see FRONTEND_ENCRYPTION.md).
  encKey: process.env.REACT_APP_ENC_KEY ?? '',
};

export default ENV_CONFIG;
